import React from 'react';
import Contact from './Contact';
import Footer from './Footer';

const Order = () => {
    document.title = 'SIHAH - Order';
    
    return (
        <section id="order" className="container-sm pt-5">
            <div className="container-sm">                
                <h1 className="text-center title mt-md-3">
                    <b>How To Order</b>
                </h1>
                <ul className="mt-5 pl-1">
                    <li>আমাদের সাথে ফোন, ইমেইল বা ফেইসবুক পেইজ এ যোগাযোগ করুন।</li>
                    <li>পণ্যের নাম ও ছবি ইনবক্স করুন ।</li>
                    <li>আপনার নাম, ঠিকানা ও ফোন নাম্বার দিয়ে অর্ডার কনফার্ম করুন।</li>
                    <li>যেকোনো প্রডাক্ট ডেলিভারির ক্ষেত্রে আগেই টাকা এডভান্স করতে হবে (কুরিয়ার ও বিকাশ চার্জ সহ) ।</li>
                    <li>অর্ডার কনফার্ম করার পর কোন অবস্থায় তা বাতিল করা সম্ভব না। আর তা বাতিল করলে এডভান্স এর টাকা ফেরত দেয়া হবে না।</li>
                    <li>নোয়াখালীতে ডেলিভারি চার্জ ফ্রী। সেক্ষেত্রে পিক আপ পয়েন্ট হবে সুপার মার্কেট অথবা নোয়াখালি বিজ্ঞান ও প্রযুক্তি বিশ্ববিদ্যালয়।</li>
                    <li>রেডি স্টক ১-৩ দিন এর মধ্যে ডেলিভারি দেয়া হয় অন্যক্ষেত্রে ৫-১০ দিন সময়ের মধ্যে ডেলিভারি দেয়া হয়।</li>
                    <li>ডেলিভারির সময় পণ্য চেক করে নিবেন। পণ্যের ত্রুটি না থাকলে কোন অবস্থায় তা ফেরত নেয়া হবে না।</li>
                    <li>কোন কারণে প্রডাক্ট দিতে না পারলে অবশ্যই এডভান্স এর টাকা ফেরত দেয়া হবে।</li>
                    <li>টাকা বিকাশ করে অবশ্যই বিকাশ নাম্বার এর লাস্ট ৩ ডিজিট ও এমাউন্ট মেসেজ করুন।</li>
                </ul>
            </div>
            <Contact />
            <Footer />
        </section>
    );
};

export default Order;